import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-636ed278"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-black flex flex-row align-middle fixed w-screen z-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { className: "text-2xl mx-10 font-bold" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://alienuniverse.io/assets/imgs/new-logo.png",
    alt: "Alien Universe",
    class: "logo"
  })
], -1))
const _hoisted_3 = { class: "flex flex-row justify-center align-middle flex-grow sharetech" }
const _hoisted_4 = { class: "flex sharetech" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavButton = _resolveComponent("NavButton")!
  const _component_NavConnect = _resolveComponent("NavConnect")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (i) => {
        return (_openBlock(), _createBlock(_component_NavButton, {
          key: i.name,
          title: i.name,
          url: i.url,
          class: _normalizeClass({ active: _ctx.path === i.url })
        }, null, 8, ["title", "url", "class"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NavConnect)
    ])
  ]))
}